import axios, { AxiosPromise } from 'axios';

export const buscaCep = (cep: string): AxiosPromise<any> =>
  axios.get(`/api/cep/${cep}`);

export const buscaCepAise = (cep: string): AxiosPromise<any> =>
  axios.get(`/api/cep/${cep}/aise`);
